import React from 'react';
import { styled } from '@mui/material';
import { TourRatingAuthorResponse } from '@lialo/core/lib/models';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ProfileAvatar from '../../../../common/ProfileAvatar/ProfileAvatar';
import ProfileAvatarLink from '../../../../common/ProfileAvatar/ProfileAvatarLink';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import config from '../../../../config';

interface Props {
  response: TourRatingAuthorResponse;
}

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  marginLeft: 22,
  paddingLeft: theme.spacing(1),
}));

const AuthorNameTypography = styled(Typography)(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.grey[600],
  display: 'block',
})) as typeof Typography;

export const AuthorResponse = (props: Props) => {
  const { response, respondent } = props.response;
  const { t } = useTranslation();

  return (
    <Root>
      <ListItemAvatar>
        {respondent?.anonymous ?? true ? (
          <ProfileAvatar size={48} user={respondent ?? undefined} />
        ) : (
          <ProfileAvatarLink hideBadge={true} size={48} user={respondent ?? undefined} />
        )}
      </ListItemAvatar>

      <ListItemText
        primary={respondent?.username ?? t('tour_detail.reviews.author_response.deleted_user')}
        secondary={
          <>
            <AuthorNameTypography component={'span'} variant={'body2'}>
              {respondent?.id === config.adminUserId ? 'lialo.com' : t('tour_detail.reviews.author_response.author')}
            </AuthorNameTypography>
            <Typography component={'span'} variant={'body1'}>
              {response}
            </Typography>
          </>
        }
      />
    </Root>
  );
};
